import {getAuthorizationToken, getHeader, getManagerHeader} from "../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../assets/Constants";
import {base64DecodeUnicode} from "../../assets/functions";

export const getAllPages = async () => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + 'pages', {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            // console.log(response.data)
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}
export const getPageById = async (id) => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + `pages/${id}`, {headers})
        .then((response) => {
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}